angular.module('pitch.playlist')
.controller('PitchMyPlaylistsCtrl', function ($scope, $controller, playlistLoader, Auth, auditionFormat, context, config, hotkeys, $state) {
    'use strict';

    angular.extend(this, $controller('PlaylistPitchCtrl', {
        $scope: $scope,
        playlistLoader: playlistLoader        
    }));

    $scope.context = context;
    $scope.auditionFormat = auditionFormat;
    $scope.searchConfig = playlistLoader.getConfig();

    Auth.getAccess()
        .then(function(access) {
            $scope.access = access;
        });

    Auth.acl('pitch_admin')
        .then(function(isGranted) {
            if(isGranted) {
                $scope.isGrantedAdmin = isGranted;
            }
        });

    $scope.playlistExportPublic = function(id) {
        var uri = config.apiUri + '/playlists/' + id + '/export?type=public';
        window.location.href = uri;
    };
    $scope.playlistExportInternal = function(id) {
        var uri = config.apiUri + '/playlists/' + id + '/export?type=internal';
        window.location.href = uri;
    };

    hotkeys.bindTo($scope)
        .add({
            combo: 's',
            callback: function(e, hotkey) {
                e.preventDefault();
                $state.go('search');
            }
        });
});



// WEBPACK FOOTER //
// ./src/PlaylistClientBundle/Resources/js/angular/controllers/PitchMyPlaylistsCtrl.js